export default __webpack_public_path__ + "static/cardImg6-6296ff1e33b25ceff665b61719c57ff3.webp";